export const locale = {
    lang: "ca",
    data: {
        TAB: {
            Status: "Estat",
            Data: "Dades",
            Alarms: "Alarmes",
            Events: "Esdeveniments",
            Info: "Info",
            Report: "Informe",
            Files: "Arxius",
        },
        DEVICES: {
            ID: "ID",
            Name: "Nom",
            Active: "Actiu",
            LastData: "Últimes Dades",
            Address: "Dispositius",
            Devices: "Dispositius",
        },
        DEVICE: {
            NoiseLevel: "Nivel Soroll",
            Limit: "Limit:",
            Info: "Información",
            Name: "Nom",
            SerialNumber: "Número de Sèrie",
            Location: "Localització",
            Latitude: "Latitud",
            Longitude: "Longitud",
            NoGPSData: "Dades GPS invàlides",
            Comments: "Comentaris",
            Last15Minutes: "Últims 15 Minuts",
            LastHour: "Última Hora",
            Last4Hours: "Últimes 4 Hores",
            Last12Hours: "Últimes 12 Hores",
            Last24Hours: "Últimes 24 Hores",
            StartDate: "Data D'inici",
            EndDate: "Data de Finalització",
            Data: "Dades",
            DateRange: "Interval",
            DataAggregation: "Mitjana",
            NoAggregation: "Valors Puntuals",
            Minutes5: "5 Minuts",
            LiveUpdate: "Actualització en Directe",
            ShowL10: "Mostra L10",
            ShowL90: "Mostra L90",
            Custom: "Custom",
            Download: "Descarregar Dades CSV",
            StartTime: "Hora Inici",
            EndTime: "Hora Fi",
            Image: "Imatge",
            DropFiles: "Arrossegueu imatge aquí",
            RemoveImage: "Elimina la imatge",
            Picture: "Imatge",
            SimOrImei: "SIM o IMEI",
            LastCalibrationDate: "Data de última calibració",
            BaseName: "Dispositiu",
            LF010PeriodLimits: "Límits LF010",
            LF010PeriodLimitsHelp: "Límits d’emissió desats i períodes de projecte assignats.",
            LF010DevicePeriod: "Període LF010",
            LF010Limit: "Límit",
            LF010SectionTitle: "Límits",
            LF010SectionHelp: "Límits actuals per període de l’LF010 i l’històric de canvis registrats.",
            LF010LimitHistory: "Històric de límits",
            LF010LimitHistoryHelp: "Canvis previs dels límits LF010 rebuts del dispositiu.",
            LF010LimitHistoryEmpty: "Encara no s’han registrat canvis de límits LF010.",
            LF010PreviousLimit: "Límit anterior",
            LF010NewLimit: "Nou límit",
            LF010ChangedAt: "Data del canvi",
            ProjectPeriod: "Període del projecte",
            NotMapped: "Sense assignar",
            UploadFile: "Pujar Arxiu",
            Minutes30: "30 Minuts",
            ShowSpectrum: "Mostrar Espectre",
        },
        ALARM: {
            ID: "Id",
            Name: "Nom",
            Description: "Descripció",
            TimeWindow: "Finestra de temps",
            Threshold: "Llindar",
            Limit: "Límit",
            LimitMode: "Mode del límit",
            LimitModeWholeDay: "Tot el dia",
            LimitModePeriods: "Per períodes",
            Severity: "Severitat",
            Field: "Camp",
            Remove: "Elimina",
            Duplicate: "Duplica",
            time_window_instant: "Instant",
            time_window_bucket_5: "5 minuts bucket",
            threshold_cross_over: "Creuem SOBRE",
            threshold_cross_below: "Creuem SOTA",
            ADD: "AFEGIR",
            SAVE: "GUARDAR",
            CANCEL: "CANCEL·LAR",
            AlarmDetail: "Detall d'alarma",
            NewAlarm: "Nova Alarma",
            Notify: "Notificar",
            Notification: "Notificació",
            Silent: "Silenciosa",
            NeedACK: "Requereix ACK",
            IgnoredDevices: "Dispositius ignorats",
            NewNotificationItem: "email/telèfon",
            NewNotificationItemEmailOnly: "email",
            NotificationChannels: "Canals de notificació",
            NotificationChannelsEmpty: "Encara no hi ha canals de notificació del projecte. Creeu-los a l'administració del projecte.",
            LegacyNotificationList: "Destinataris legacy mantinguts per compatibilitat",
            ProjectAlarm: "Alarmes del projecte",
            AlarmDeleteTitle: "Alerta",
            AlarmDeleteMessage: "Aquesta alarma té {{activeEvents}} esdeveniments actius. \nSegur que la vols eliminar?",
        },
        SEVERITY: {
            alarm: "Alarma",
            info: "Informació",
            success: "Èxito",
            warning: "Atenció",
        },
        FIELD: {
            sound_pressure_level: "Nivel Soroll (dBA)",
            sound_pressure_level_c: "Nivel Soroll (dBC)",
            sound_pressure_level_1m: "Nivel Soroll (dBA, 1 min)",
            sound_pressure_level_1m_sensor_2: "Sound Pressure (Sensor 2)",
            sound_pressure_level_c_1m: "Nivel Soroll (dBC, 1 min)",
            sound_pressure_level_c_minus_a: "dBC - dBA",
            rolling_5s: "Rolling 5 segons (dBA)",
            rolling_5s_c: "Rolling 5 segons (dBC)",
            rolling_5: "Rolling 5 minuts (dBA)",
            rolling_5_c: "Rolling 5 minuts (dBC)",
            rolling_30: "Rolling 30 minuts (dBA)",
            rolling_30_c: "Rolling 30 minuts (dBC)",
            battery: "Bateria",
            power_supply_status: "Font d'alimetació",
            spectrum_13_octave: "Espectre 1/3 Octava",
            temperature: "Temperatura Ext.",
            overload: "Sobrecàrrega",
            underrange: "Underrange",
            spectrum_13_octave_1m: "Espectre 1/3 Octava (1 min)",
            wifi_signal_level: "Senyal WiFi",
            cellullar_signal_level: "Senyal Cel·lular",
            free_storage: "Espai Lliure",
        },
        REPORT: {
            General: "Dades Generals",
            Device: "Equip / Número de Sèrie",
            Address: "Adreça",
            Comments: "Comentaris",
            Register: "Registre",
            GenerateReport: "Generar Informe",
            Dates: "Dates",
            GPS: "Coordenades GPS",
            Photo: "Fotografia",
            ProjectName: "Nom del Projecte",
            RegisteredParameters: "Paràmetres Registrats",
            Graph: "Gràfic",
            Observations: "Observacions",
            CustomAlarm: "Limit Personalitzat",
            Limits: "Límits",
            Fields: "Camps",
            Map: "Mapa",
            DataSetup: "Configuració de Dades",
            ReportOptions: "Opcions de l'Informe",
            Options: "Opcions",
            Interval: "Interval",
            AWeighting: "A",
            CWeighting: "C",
            Color: "Color",
            LineStyle: "Línia",
            Interval1s: "1s",
            Interval5sRolling: "5s rolling",
            Interval5minBucket: "5min (bucket)",
            Interval5minRolling: "5min rolling max",
            Interval30minRolling: "30min rolling max",
            LineStyleSolid: "Sòlida",
            LineStyleDashed: "Discontínua",
            LineStyleDotted: "Puntejada",
            DeviceComments: "Comentaris del Dispositiu",
            PeriodBands: "Mostrar bandes de període",
            LAeq1s: "LAeq 1s",
            LCeq1s: "LCeq 1s",
            LAeq5sRolling: "LAeq 5s rolling",
            LCeq5sRolling: "LCeq 5s rolling",
            LAeq5minBucket: "LAeq 5min (bucket)",
            LCeq5minBucket: "LCeq 5min (bucket)",
            LAeq5minRolling: "LAeq 5min rolling (max)",
            LCeq5minRolling: "LCeq 5min rolling (max)",
            LAeq30minRolling: "LAeq 30min rolling (max)",
            LCeq30minRolling: "LCeq 30min rolling (max)",
            LAqe30: "LAeq 30min",
            LAqe5: "LAeq 5min",
            LAqe1: "LAeq 1seg",
            LAqe5s: "LAeq 5seg",
            YAxisRange: "Rang Eix Y",
            YAxisMin: "Mínim",
            YAxisMax: "Màxim",
        },
        FILE: {
            Name: "Nom",
            Status: "Estat",
            UploadDate: "Data de pujada",
            DropFile: "Arrossegueu arxiu aquí",
            uploaded: "Pujat",
            processing: "Processant",
            processed: "Processat",
        },
    },
};
